import { debounce } from "@sazka/utils/debounce";

function updateVhUnits() {
    const vh100 = window.innerHeight;
    document.documentElement.style.setProperty("--vh100", `${vh100}px`);
}

export function useVhUnitsCalculation() {
    updateVhUnits();
    window.addEventListener("resize", debounce(updateVhUnits, 10, false), { passive: true });
}
